"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddMemberToAdAccountRequestToJSON = exports.AddMemberToAdAccountRequestFromJSONTyped = exports.AddMemberToAdAccountRequestFromJSON = exports.instanceOfAddMemberToAdAccountRequest = void 0;
var AdAccountRole_1 = require("./AdAccountRole");
/**
 * Check if a given object implements the AddMemberToAdAccountRequest interface.
 */
function instanceOfAddMemberToAdAccountRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "memberId" in value;
    isInstance = isInstance && "role" in value;
    return isInstance;
}
exports.instanceOfAddMemberToAdAccountRequest = instanceOfAddMemberToAdAccountRequest;
function AddMemberToAdAccountRequestFromJSON(json) {
    return AddMemberToAdAccountRequestFromJSONTyped(json, false);
}
exports.AddMemberToAdAccountRequestFromJSON = AddMemberToAdAccountRequestFromJSON;
function AddMemberToAdAccountRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'memberId': json['member_id'],
        'role': (0, AdAccountRole_1.AdAccountRoleFromJSON)(json['role']),
    };
}
exports.AddMemberToAdAccountRequestFromJSONTyped = AddMemberToAdAccountRequestFromJSONTyped;
function AddMemberToAdAccountRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'member_id': value.memberId,
        'role': (0, AdAccountRole_1.AdAccountRoleToJSON)(value.role),
    };
}
exports.AddMemberToAdAccountRequestToJSON = AddMemberToAdAccountRequestToJSON;
